import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { draftOrdersApi, type DraftOrderListParams } from '../api/draft-orders-api';

import { draftOrderKeys } from './draft-order-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function draftOrderListQueryOptions(storeId: string, params: DraftOrderListParams) {
  return queryOptions({
    queryKey: draftOrderKeys.list(storeId, params),
    queryFn: () => draftOrdersApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useDraftOrders(storeId: string, params: DraftOrderListParams) {
  return useQuery(draftOrderListQueryOptions(storeId, params));
}
